import { FC, useMemo } from 'react'
import { FloatingPane, OpportunityReviewFloatingPane as OpportunityReviewFloatingPaneType } from 'interfaces/floatingPanes'
import { createFloatingPaneByTypeSelector } from 'selectors/floatingPanesSelectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { OpportunityReviewCommentsPane } from 'components/features/pfm/OpportunityReviewCommentsPane/OpportunityReviewCommentsPane'
import { OpportunityReviewComposePane } from 'components/features/pfm/OpportunityReviewComposePane/OpportunityReviewComposePane'
import { MergePageContext } from 'components/features/pfm/MergePageContext/MergePageContext'

const TYPED_PANE: Pick<FloatingPane, 'type'> = {
  type: 'opportunity-review',
}

type OpportunityReviewFloatingPaneProps = {

}

export const OpportunityReviewFloatingPane: FC<OpportunityReviewFloatingPaneProps> = (props) => {
  const {} = props

  const paneSelector = useMemo(createFloatingPaneByTypeSelector, [])
  const pane = useStoreSelector((state) => paneSelector(state, TYPED_PANE)) as OpportunityReviewFloatingPaneType | null

  const child = useMemo(() => {
    if (!pane) {
      return null
    }

    if (pane.payload.mode === 'comments') {
      return (
        <OpportunityReviewCommentsPane />
      )
    }

    if (pane.payload.mode === 'write-review') {
      return (
        <OpportunityReviewComposePane />
      )
    }

    return null
  }, [pane])

  if (!pane || !child) {
    return null
  }

  return (
    <MergePageContext isPublicPage={ !!pane.payload.isPublic }>
      { child }
    </MergePageContext>
  )
}
